import { SyncRouteUpdatedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import RouteBreakdownSubHandlerQuery from '../../queries/routes/RouteBreakdownSubHandlerQuery';

export default ({ store, route }: SyncRouteUpdatedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;
  const routeId = rootStore.ui.selectedRoute?.id;

  if (projectId != null && routeId != null && routeId === route.id) {
    store.queryRouteById({ projectId, routeId }, RouteBreakdownSubHandlerQuery);
  }
};
